import api, { apiPrefix } from './Api';

const affiliatePublicApiPrefix = `${apiPrefix}/affiliate-public`;

export const sendAffiliateClick = async (): Promise<void> =>
  api.post(`${affiliatePublicApiPrefix}/click`);
